import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class PageHeader extends React.Component {
  static propTypes = {
    avatarUrl: PropTypes.string,
    children: PropTypes.any,
    // Avoid conflicting with built in "title" attribute - use headerTitle instead
    headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
      .isRequired,
  };

  static defaultProps = {
    avatarUrl: null,
    children: null,
    headerTitle: null,
  };

  render() {
    const innerContainerClassName = this.props.avatarUrl
      ? 'PageHeader-inner-container--with-avatar'
      : 'PageHeader-inner-container--without-avatar';

    return (
      <div className={'PageHeader'}>
        <div className={'PageHeader-container'}>
          {!this.props.avatarUrl ? null : (
            <img className={'PageHeader-avatar'} src={this.props.avatarUrl} />
          )}
          <span className={innerContainerClassName}>
            <div className={'PageHeader-title-container'}>
              <h1 className={'PageHeader-title'}>{this.props.headerTitle}</h1>
            </div>
            <span className={'PageHeader-button-container'}>
              {this.props.children}
            </span>
          </span>
        </div>
      </div>
    );
  }
}
